import {Component, Input} from '@angular/core';
import {SummaryContactValue} from '@portal-workspace/grow-shared-library';
import { MatDividerModule } from '@angular/material/divider';
import { CellComponent } from './cell.component';

import { EllipsisPipe } from '../../pipes/ellipsis.pipe';
import { SignerRolePipe } from '../../pipes/signer-role.pipe';


@Component({
    selector: 'contacts-summary',
    template: `
    @for (contact of contacts; track contact; let index = $index) {
      <!-- the first heading is spaced by the mt-3 wrapper the parent summary puts around us -->
      <div class="row" [class.mt-3]="index > 0">
        <div class="col-12">
          <div class="application-subsection-title">{{contactTitle(contact, index)}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Title</div>
            <div body>{{contact.title?.name}}</div>
          </cell>
        </div>
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>First name</div>
            <div body><p [innerHTML]="contact.firstName | ellipsis:10"></p></div>
          </cell>
        </div>
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Last name</div>
            <div body><p [innerHTML]="contact.lastName | ellipsis:10"></p></div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Mobile number</div>
            <div body>{{contact.mobileNumber}}</div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <cell>
            <div label>Email address</div>
            <div body>{{contact.email}}</div>
          </cell>
        </div>
        @if (contact.areaCode) {
          <div class="col-lg-3 col-md-12">
            <cell>
              <div label>Area code</div>
              <div body>{{contact.areaCode}}</div>
            </cell>
          </div>
        }
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Business role</div>
            <div body>{{contact.role ?? ''}}</div>
          </cell>
        </div>
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Application role</div>
            <div body>{{contact.signerRole | signerRole}}</div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
    }
    `,
    standalone: true,
    imports: [CellComponent, MatDividerModule, EllipsisPipe, SignerRolePipe]
})
export class ContactsSummaryComponent {

  @Input({required: false}) contacts?: SummaryContactValue[] | null;

  contactTitle(contact: SummaryContactValue, index: number): string {
    return contact.isPrimaryContact ? `Contact ${index + 1} (Primary contact)` : `Contact ${index + 1}`;
  }

}
